import {FETCHED_TASKS_SUCCESSFULLY} from '../constants';

const initial_state = {
  tasks_bare_minimum: {}
}
const TaskReducer = (state = initial_state, action) => {
  switch (action.type) {
    case FETCHED_TASKS_SUCCESSFULLY:
      return {...state, tasks_bare_minimum: {...action.payload}};
    default:
      return state;
  }
}
export default TaskReducer;